import React, { useEffect } from "react";
import AgentForm from "./AgentForm";
import "../css/register.agent.css";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useAgent } from "../../../contexts/AgentsContext";

const EditAgent = () => {
  const { agents, initializeEdit, getAgent } = useAgent();

  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  const agentId = id || (location.state && location.state.agentId);

  useEffect(() => {
    if (!agentId) {
      navigate("/agents", { replace: true });
      return;
    }

    const initialize = async () => {
      const agent = agents?.find((agent) => agent?.agent_id === agentId);

      if (agent) {
        initializeEdit(agent);
      } else {
        try {
          const fetchedAgent = await getAgent(agentId);

          if (fetchedAgent) {
            initializeEdit(fetchedAgent?.data);
          } else {
            setTimeout(() => {
              navigate("/agents", { replace: true });
            }, 1000);
          }
        } catch (error) {
          setTimeout(() => {
            navigate("/agents", { replace: true });
          }, 1000);
        }
      }
    };

    initialize();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agentId]);

  if (!agentId) {
    return null;
  }

  return (
    <>
      <div className="edit-agent-container">
        <AgentForm title="Edit Agent" type="edit" agentId={agentId} />
      </div>
    </>
  );
};

export default EditAgent;
